// Template par défaut pour un nouveau profil
export const defaultProfileTemplate = {
  prenom: '',
  nom: '',
  email: '',
  telephone: '',
  entreprise: '',
  poste: '',
  siteWeb: '',
  adresse: '',
  ville: '',
  codePostal: '',
  pays: '',
  linkedin: '',
  facebook: '',
  x: '',
  github: '',
  instagram: '',
  youtube: '',
  tiktok: '',
  behance: '',
  dribbble: '',
  medium: '',
  discord: '',
  whatsapp: '',
  telegram: '',
  skype: '',
  username: '', // Champ explicite pour le username
  isPublic: true,
  logoUrl: '', // Champ pour l'URL du logo
  qrCodeUrl: '', // URL du QR code généré
  qrStyle: {
    fgColor: '#000000',
    bgColor: '#ffffff',
    style: 'squares' as 'dots' | 'squares' | 'rounded'
  }
};
